import { createFileRoute } from "@tanstack/react-router";
import NoteTakingMethodsGuideFr from "@/pages/resources/fr/NoteTakingMethodsGuideFr";

export const Route = createFileRoute("/fr/learn/note-taking-methods")({
  head: () => ({
    meta: [
        {
            "title": "Méthodes de prise de notes : Cornell, Mind Maps et plus | System Atlas"
        },
        {
            "name": "description",
            "content": "Comparez les méthodes de prise de notes les plus efficaces. Trouvez le système adapté à votre style d'apprentissage."
        },
        {
            "property": "og:title",
            "content": "Méthodes de prise de notes : Cornell, Mind Maps et plus | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Comparez les méthodes de prise de notes les plus efficaces. Trouvez le système adapté à votre style d'apprentissage."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/fr/learn/note-taking-methods"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Méthodes de prise de notes : Cornell, Mind Maps et plus | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Comparez les méthodes de prise de notes les plus efficaces. Trouvez le système adapté à votre style d'apprentissage."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/fr/learn/note-taking-methods"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/note-taking-methods"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/note-taking-methods"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/note-taking-methods"
        }
    ],
  }),
  component: NoteTakingMethodsGuideFr,
});
